/* eslint-disable no-unused-vars */
/**
 * @file 路由组件
 * @author mengchen <sisimengchen@gmail.com>
 */
import React from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
// import queryString from 'query-string';
import { queryStringToObject } from 'utils/index';
import { history } from 'core/history';
import routes from 'core/routes';
import { redirect } from './redirect';

const CoreRouter = () => (
  <ConnectedRouter history={history}>
    <Switch>
      {routes.map((route = {}, index) => {
        const { component: PageComponent, title, ...rest } = route;
        return (
          <Route
            key={route.path || index}
            {...rest}
            render={routeProps => {
              window.document.title = title;
              const { location = {} } = routeProps;
              location.query = location.search
                ? queryStringToObject(location.search)
                : {};
              // location.path = `${location.pathname}${location.search}${location.hash}`;
              const redirectTo = redirect(location);
              if (redirectTo) {
                return <Redirect to={redirectTo} />;
              }
              return <PageComponent {...routeProps} />;
            }}
          />
        );
      })}
    </Switch>
  </ConnectedRouter>
);

export default CoreRouter;
